import _ from 'underscore';

export const MEDIA_RESOURCE_TYPES = {
	image: 'image',
	video: 'video',
	audio: 'audio',
	index: 'index',
};

export const getSortedNumberBasedOnWidth = (list: any[]) => {
	let sortedArray = list.sort((a, b) => (a.width > b.width ? 1 : -1)); //to check where >= hold good
	return sortedArray;
};

export const getThumbnailFromRenditionsBasedOnWidth = (renditions: any[], width?: number) => {
	if (!renditions) {
		return '';
	}

	if (!width) {
		width = 220;
	}

	renditions = [].slice.call(renditions).sort((a: any, b: any) => (a.width > b.width ? 1 : -1));
	renditions = getSortedNumberBasedOnWidth(renditions).reverse();

	for (let rendition in renditions) {
		if (renditions && renditions[rendition] && renditions[rendition].width) {
			let eachThumbanilWidth = Number(renditions[rendition].width);
			if (eachThumbanilWidth >= width) {
				// Number can be changed based on width of parent div
				return renditions[rendition].url;
			}
		}
	}

	if (renditions && renditions[0] && renditions[0].url) {
		return renditions[0].url;
	}

	return '';
};

export const getThumbnailFromResourcesWithoutThumbnailId = (resources: any[]) => {
	let renditions: any[] = [];
	let resourcesWithImages = resources.filter(
		(eachResource) => eachResource && eachResource.type === MEDIA_RESOURCE_TYPES.image && eachResource.renditions
	);
	let resourcesWithThumbnail = resourcesWithImages.filter(
		(eachResource) => eachResource && eachResource.rel && eachResource.rel.indexOf('thumbnail') != -1
	);
	if (resourcesWithThumbnail.length > 0) {
		return getSortedNumberBasedOnWidth(resourcesWithThumbnail[0].renditions);
	} else if (resourcesWithImages.length > 0) {
		return getSortedNumberBasedOnWidth(resourcesWithImages[0].renditions);
	}
	return renditions;
};

export const getLowQThumbnail = ({ posters, images }: { posters: any[]; images: any[] }) => {
	return getLowQCoverFromRenditions(posters, "thumbnail") || getLowQCoverFromRenditions(images)
}

export const getHighQThumbnailFromResource = (resources: any[]) => {
	const images = resources?.filter(({ type }: any) => type === 'image');

	const thumbnail = images?.find(({ rel }: any) => rel?.includes('thumbnail'));
	const renditionList = (thumbnail ? thumbnail.renditions : images[0]?.renditions) ?? [];
	const sortedRenditionsList = renditionList.sort((a: any, b: any) => (a.width > b.width ? 1 : -1));
	const renditionsBasedOnWidth = getSortedNumberBasedOnWidth(sortedRenditionsList);
	return renditionsBasedOnWidth[0]?.links?.[0].href ?? "";
}

export const getHighQThumbnail = ({ posters, images }: { posters: any[]; images: any[] }) => {
	return getHighQCoverFromRenditions(posters, "thumbnail") || getHighQCoverFromRenditions(images)
}

export const getLowQCoverFromRenditions = (images: any[], type?: string)=> {
	if ((images ?? []).length === 0) {
		return '';
	}
	const renditionsList = !type ? images.filter((image: any) => (image.rel ?? []).length === 0)
		: images.filter((image: any) => image.rel && image.rel.indexOf(type) !== -1);
	const sortedRenditionsList = renditionsList.sort((a, b) => (a.width > b.width ? 1 : -1));
	const renditions = getSortedNumberBasedOnWidth(sortedRenditionsList);
	return renditions[0]?.url ?? "";
};

export const getHighQCoverFromRenditions = (images: any[], type?: string) => {
	if ((images ?? []).length === 0) {
		return '';
	}
	const renditionsList = !type ? images.filter((image: any) => (image.rel ?? []).length === 0)
		: images.filter((image: any) => image.rel && image.rel.indexOf(type) !== -1);
	const sortedRenditionsList = renditionsList.sort((a, b) => (a.width > b.width ? 1 : -1));
	const renditions = getSortedNumberBasedOnWidth(sortedRenditionsList).reverse();
	return renditions[0]?.url ?? "";
};

export const findHighestQualityVideo = (downloadables: any[]) => {
	let highestQualityVideo = 0;
	let highestQualityVideoUrl;

	if (downloadables.length > 0) {
		highestQualityVideoUrl = downloadables[0].url;
	}

	downloadables.forEach(function (downloadable) {
		if (parseInt(downloadable.quality, 10) > highestQualityVideo) {
			highestQualityVideo = parseInt(downloadable.quality, 10);
			highestQualityVideoUrl = downloadable.url;
		}
	});
	return highestQualityVideoUrl;
};

export const getMediaRestrictToken = ({ mediaId, isScenario, tokens, restrictedToken, scenario, unlockedMedias }
	: { scenario?: any; mediaId?: string; scenarioId?: string; isScenario?: boolean; tokens?: any[], restrictedToken?: any; unlockedMedias?: any[] }) => {
	let result = null;
	const splitter = isScenario ? '-scenario-' : '-media-';
	const checkMediaId = (isScenario ? scenario?.id : mediaId) ?? "";

	if (tokens && (tokens ?? []).length > 0) {
		tokens.forEach((token: string) => {
			const checks = token.split(splitter);
			result = token.includes(checkMediaId) ? checks[0] : null;
		});
	}

	if (isScenario && !restrictedToken?.mediaId && !scenario && restrictedToken?.token) {
		result = restrictedToken.token;
	}

	if (restrictedToken && checkMediaId === restrictedToken.mediaId && restrictedToken.token) {
		result = restrictedToken.token;
	}

	const unlockedMedia = (unlockedMedias ?? []).find((u: any) => u.mediaId === checkMediaId);
	if (unlockedMedia && unlockedMedia.unlocked) {
		result = unlockedMedia.unlocked;
	}

	return result;
}
interface Word {
	startTime: number;
	endTime: number;
	content: string;
}

export interface TranscriptSegment {
	start: number;
	end: number;
	text: string;
	active?: boolean;
	id: string;
}

export const obtainTranscriptSegment = (data: any) => {
	const SENTENCE_LENGTH = 10;
	let transcriptSegment = [];
	let currentAlternative = [];
	let breakAfterNextWord = false;

	if (data) {
		/*  data.map(item => { */
		for (let i = 0; i < data.length; i++) {
			const word = data[i];

			if (
				word.content.endsWith('.') ||
				word.content.endsWith('!') ||
				word.content.endsWith('?') ||
				word.content.endsWith('¤')
			) {
				breakAfterNextWord = true;
			}

			if (breakAfterNextWord) {
				currentAlternative.push(word);
				if (currentAlternative.length > SENTENCE_LENGTH) {
					for (let i = 0, j = currentAlternative.length; i < j; i += SENTENCE_LENGTH) {
						let tempArray = currentAlternative.slice(i, i + SENTENCE_LENGTH);
						transcriptSegment.push(tempArray);
					}
					currentAlternative = [];
					breakAfterNextWord = false;
					continue;
				} else {
					transcriptSegment.push(currentAlternative);
					currentAlternative = [];
					breakAfterNextWord = false;
					continue;
				}
			}
			currentAlternative.push(word);
		}
	}

	return transcriptSegment;
};

export const convertToTranscriptSegment = (transcriptEntries: any): TranscriptSegment[] => {
	const segments: Word[][] = obtainTranscriptSegment(transcriptEntries);
	let transcriptSegment = [];

	for (let i = 0; i < segments.length; i++) {
		let minStart = 99999999999999;
		let maxEnd = 0;
		let text = '';
		let newLineCounter = 0;

		segments[i].map((word: Word) => {
			if (word.startTime < minStart) {
				minStart = word.startTime;
			}

			if (word.endTime > maxEnd) {
				maxEnd = word.endTime;
			}

			text += word.content + ' ';
			newLineCounter = newLineCounter + 1;

			if (newLineCounter === 5) {
				text = text + '\n';
				newLineCounter = 0;
			}
		});

		transcriptSegment.push({
			start: minStart,
			end: maxEnd,
			text: text,
			id: ""
		});
	}

	return transcriptSegment;
};